(function () {
    // --- Elements ---
    const button = document.getElementById("cbwButton");
    const label = document.getElementById("cbwLabel");
    const modal = document.getElementById("cbwModal");
    const closeBtn = document.getElementById("cbwClose");
    const form = document.getElementById("cbwForm");
    const input = document.getElementById("cbwInput");
    const messages = document.getElementById("cbwMessages");
    const welcome = document.getElementById("cbwWelcome");
  
    if (!button || !modal || !messages) return;
  
    // --- Config ---
    const API_BASE = "https://rbot.datalink.rextag.com";
    const CREATE_SESSION_URL = API_BASE + "/create_session";
    const CLEAR_COOKIE_URL = API_BASE + "/clear_session_cookie";
    const CHAT_URL = API_BASE + "/chat";
    const CONV_BY_SESSION_URL = (sid) =>
      API_BASE + "/conversations_by_session/" + encodeURIComponent(sid);
  
    // LocalStorage key used to persist session_id
    const LS_KEY = "chatbot_session";
  
    // Active session used for /chat (and for history loading)
    let activeSessionId = null;
  
    // Prevent multiple init runs if user clicks quickly
    let isInitRunning = false;
  
    // --- UI helpers ---
    function updateWelcomeVisibility() {
      if (!welcome) return;
      const hasMsgs = messages && messages.children && messages.children.length > 0;
      welcome.style.display = hasMsgs ? "none" : "";
    }
  
    function clearMessagesUI() {
      messages.innerHTML = "";
      updateWelcomeVisibility();
    }
  
    function autoResizeTextarea() {
      if (!input) return;
      input.style.height = "auto";
      input.style.height = Math.min(input.scrollHeight, 110) + "px";
    }
    if (input) input.addEventListener("input", autoResizeTextarea);
  
    // Send on Enter (Shift+Enter = newline)
    if (input && form) {
      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
          e.preventDefault();
          form.requestSubmit
            ? form.requestSubmit()
            : form.dispatchEvent(new Event("submit", { cancelable: true }));
        }
      });
    }
  
    function setSending(isSending) {
      if (input) input.disabled = isSending;
      const sendBtn = form ? form.querySelector('button[type="submit"]') : null;
      if (sendBtn) sendBtn.disabled = isSending;
    }
  
    // function addMsg(role, text) {
    //   const div = document.createElement("div");
    //   div.className = "cbw__msg " + (role === "user" ? "user" : "bot");
    //   div.textContent = text;
  
    //   messages.appendChild(div);
    //   messages.scrollTop = messages.scrollHeight;
    //   updateWelcomeVisibility();
  
    //   // Optional: if you use CSS rule .cbw__msg.bot.is-long { ... }
    //   if (role !== "user") {
    //     requestAnimationFrame(() => {
    //       const overflows = div.scrollHeight > div.clientHeight + 1;
    //       if (overflows) div.classList.add("is-long");
    //     });
    //   }
    // }
  
    function addMsg(role, text) {
      const div = document.createElement("div");
      div.className = "cbw__msg " + (role === "user" ? "user" : "bot");
  
      if (role === "user") {
        div.textContent = text; // keep user safe
      } else {
        // Markdown -> HTML
        const html = window.marked
          ? marked.parse(String(text || ""))
          : String(text || "").replace(/\n/g, "<br>");
  
        div.innerHTML = html;
  
        // Make links safe + open in new tab
        div.querySelectorAll("a").forEach((a) => {
          a.target = "_blank";
          a.rel = "noopener noreferrer";
        });
      }
  
      messages.appendChild(div);
      messages.scrollTop = messages.scrollHeight;
      updateWelcomeVisibility();
    }
  
    // --- Loader helpers ---
    let loaderEl = null;
  
    function showLoader() {
      if (loaderEl) return loaderEl;
  
      loaderEl = document.createElement("div");
      loaderEl.className = "cbw__msg bot cbw__loader";
      loaderEl.innerHTML = `
        <div class="cbw__typing" aria-label="Assistant is typing">
          <span></span><span></span><span></span>
        </div>
      `;
      messages.appendChild(loaderEl);
      messages.scrollTop = messages.scrollHeight;
      updateWelcomeVisibility();
      return loaderEl;
    }
  
    function hideLoader() {
      if (loaderEl && loaderEl.parentNode) loaderEl.parentNode.removeChild(loaderEl);
      loaderEl = null;
    }
  
    // --- Storage helpers ---
    function getStoredSessionId() {
      try {
        return localStorage.getItem(LS_KEY) || null;
      } catch {
        return null;
      }
    }
  
    function setStoredSessionId(sid) {
      try {
        localStorage.setItem(LS_KEY, sid);
      } catch {}
    }
  
    function removeStoredSessionId() {
      try {
        localStorage.removeItem(LS_KEY);
      } catch {}
    }
  
    // --- Network helpers ---
    async function fetchText(url, { method = "GET", body } = {}) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 25000);
  
      try {
        const res = await fetch(url, {
          method,
          headers: body ? { "Content-Type": "application/json" } : undefined,
          body: body ? JSON.stringify(body) : undefined,
          credentials: "include", // cookie-based
          signal: controller.signal
        });
  
        const raw = await res.text();
        return { res, raw };
      } finally {
        clearTimeout(timeout);
      }
    }
  
    function tryParseJSON(raw) {
      try {
        return raw ? JSON.parse(raw) : null;
      } catch {
        return null;
      }
    }
  
    async function createAndStoreSession() {
      const { res, raw } = await fetchText(CREATE_SESSION_URL, { method: "POST" });
      if (!res.ok) {
        throw new Error(`create_session failed: HTTP ${res.status} ${raw.slice(0, 200)}`);
      }
  
      const data = tryParseJSON(raw);
      const sid = data && typeof data.session_id === "string" ? data.session_id : null;
      if (!sid) throw new Error("create_session: missing session_id in response");
  
      activeSessionId = sid;
      setStoredSessionId(sid);
      return sid;
    }
  
    async function clearSessionCookie() {
      // best-effort
      try {
        await fetchText(CLEAR_COOKIE_URL, { method: "POST" });
      } catch {}
    }
  
    async function loadConversationHistory(sessionId) {
      const { res, raw } = await fetchText(CONV_BY_SESSION_URL(sessionId), { method: "GET" });
  
      if (res.status === 404) {
        // Normal: no messages yet
        return [];
      }
      if (!res.ok) {
        throw new Error(`conversations_by_session failed: HTTP ${res.status} ${raw.slice(0, 200)}`);
      }
  
      const data = tryParseJSON(raw);
      return Array.isArray(data?.messages) ? data.messages : [];
    }
  
    function renderHistory(msgs) {
      clearMessagesUI();
      for (const m of msgs) {
        const role = m.role === "assistant" ? "bot" : "user";
        addMsg(role, m.message || "");
      }
      updateWelcomeVisibility();
    }
  
    function extractReply(data) {
      if (!data) return null;

      let main =
        (typeof data.response === "string" && data.response) ||
        (typeof data.reply === "string" && data.reply) ||
        (typeof data.answer === "string" && data.answer) ||
        (typeof data.message === "string" && data.message) ||
        (data.data && typeof data.data.reply === "string" && data.data.reply) ||
        null;

      const parts = [];
      if (typeof main === "string" && main.trim()) parts.push(main.trim());
      if (typeof data.follow_up === "string" && data.follow_up.trim())
        parts.push(data.follow_up.trim());
      if (typeof data.second_followup === "string" && data.second_followup.trim())
        parts.push(data.second_followup.trim());

      const combined = parts.join("\n\n");
      return combined || null;
    }
  
    async function postChat(sessionId, text) {
      const { res, raw } = await fetchText(CHAT_URL, {
        method: "POST",
        body: {
          message: text,
          session_id: sessionId,
          page: location.href
        }
      });
  
      const data = tryParseJSON(raw);
      return { res, raw, data };
    }
  
    // --- Schema logic ---
    // On open:
    // 1) read session from localStorage
    // 2) if missing -> create_session and store
    // 3) always load history for that session (404 => empty, do NOT create new session)
    async function initOnOpen() {
      if (isInitRunning) return;
      isInitRunning = true;
  
      try {
        // 1) read stored session
        let sid = getStoredSessionId();
        activeSessionId = sid;
  
        // 2) if missing -> create
        if (!sid) {
          sid = await createAndStoreSession();
        }
  
        // 3) always load history on open
        try {
          const history = await loadConversationHistory(sid);
          renderHistory(history);
        } catch (e) {
          console.warn("History load failed:", e);
          // keep UI empty; do NOT create new session
          clearMessagesUI();
        }
      } finally {
        isInitRunning = false;
      }
    }
  
    // --- UI open/close ---
    function open() {
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      if (label) label.style.display = "none";
      setTimeout(() => input && input.focus(), 0);
  
      initOnOpen();
    }
  
    function close() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      if (label) label.style.display = "";
    }
  
    function toggle() {
      modal.classList.contains("is-open") ? close() : open();
    }
  
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal.classList.contains("is-open")) close();
    });
  
    // --- Send logic ---
    async function ensureActiveSession() {
      if (activeSessionId) return activeSessionId;
  
      const stored = getStoredSessionId();
      if (stored) {
        activeSessionId = stored;
        return activeSessionId;
      }
  
      return await createAndStoreSession();
    }
  
    // Recovery rules:
    // - 401/403 from /chat => cookie/session mismatch/expired
    //   -> clear cookie (best-effort) + create new session + retry once
    async function sendWithRecovery(text) {
      await ensureActiveSession();
  
      // attempt 1
      let { res, data } = await postChat(activeSessionId, text);
      if (res.ok) {
        const reply = extractReply(data);
        return reply || "Sorry — I couldn’t generate a reply. Please try again.";
      }
  
      // recover once on auth-related issues
      if (res.status === 401 || res.status === 403) {
        await clearSessionCookie();
        removeStoredSessionId();
        await createAndStoreSession();
  
        ({ res, data } = await postChat(activeSessionId, text));
        if (res.ok) {
          const reply = extractReply(data);
          return reply || "Sorry — I couldn’t generate a reply. Please try again.";
        }
      }
  
      throw new Error(`chat failed: HTTP ${res.status}`);
    }
  
    async function handleSend(text) {
      const clean = (text || "").trim();
      if (!clean) return;
  
      if (!modal.classList.contains("is-open")) open();
  
      addMsg("user", clean);
  
      if (input) {
        input.value = "";
        autoResizeTextarea();
      }
  
      setSending(true);
      showLoader();
  
      try {
        const reply = await sendWithRecovery(clean);
        hideLoader();
        addMsg("bot", reply);
      } catch (err) {
        hideLoader();
        addMsg("bot", "Sorry — something went wrong.");
        console.error("Chatbot error:", err);
      } finally {
        setSending(false);
        input && input.focus();
      }
    }
  
    // --- Events ---
    button.addEventListener("click", toggle);
    if (closeBtn) closeBtn.addEventListener("click", close);
  
    if (form) {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        handleSend(input && input.value ? input.value : "");
      });
    }
  
    if (welcome) {
      welcome.addEventListener("click", (e) => {
        const btn = e.target.closest(".cbw__quick-btn");
        if (!btn) return;
        handleSend(btn.getAttribute("data-q") || "");
      });
    }
  
    // Initial state
    updateWelcomeVisibility();
    autoResizeTextarea();
  })();
  